module.exports = __webpack_public_path__ + "static/img/3.0cd08a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhwhyx/3.jpg
// module id = L5+D
// module chunks = 1